<div class="cw-modal">
    <div class="cw-modal-body">
        <ng-content></ng-content>
    </div>
</div>
<div class="cw-modal-background"></div>